import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import authService from './services/authService';
// Importar el icono desde src y establecerlo como icono de la pestaña
import feIcon from './assets/images/Logo-removebg-preview.ico';

// Configurar interceptores de axios para autenticación
authService.setupAxiosInterceptors();
// Registrar el handler que intenta cerrar sesión al cerrar la pestaña/ventana
window.addEventListener('beforeunload', () => {
  // llamar método no bloqueante para enviar logout
  try {
    authService.logoutOnUnload();
  } catch (e) {
    // ignore
  }
});

function setFavicon(href) {
  const linkId = 'dynamic-app-favicon';
  let link = document.getElementById(linkId);
  if (!link) {
    link = document.createElement('link');
    link.id = linkId;
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.type = 'image/x-icon';
  link.href = href;
}

setFavicon(feIcon);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);
